export default "__VITE_ASSET__DrFtz2x9__"